// src/hooks/ScreenSelector.jsx
import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';
import { screens } from '../screens/registry';

const Fallback = () => (
    <div className="flex items-center justify-center py-10">
        <Spin size="large" />
    </div>
);

const NotFound = () => (
    <div className="p-6 text-center text-slate-500">
        No se encontró la pantalla solicitada.
    </div>
);

export const ScreenSelector = () => {
    const openScreen = useSelector((state) => state.ui.openScreen);
    const Component = screens[openScreen] || NotFound;

    return (
        <Suspense fallback={<Fallback />}>
            <Component />
        </Suspense>
    );
};
